import ProviderConfiguration from './components/ProviderConfiguration.js';
import connect from './connect';
import './assets/ProviderConfiguration.css';

export default connect(ProviderConfiguration);



// WEBPACK FOOTER //
// ./src/routes/ProviderConfiguration/index.js